import { UserFull } from '@wellesley/openapi'

import { useGetApiV1UsersByUserIdQuery } from '../userApi'

type HookProps = {
  userId?: string
  canFetch?: boolean
  htmlContent?: boolean
}

export const useGetUserById = ({
  userId = '',
  canFetch = true,
  htmlContent = true,
}: HookProps) => {
  const { data, error, isLoading, isFetching } = useGetApiV1UsersByUserIdQuery(
    {
      userId,
      full: true,
      htmlContent,
    },
    {
      skip: !userId || !canFetch,
    },
  )

  return { data: data as UserFull, error, isLoading, isFetching }
}
